import * as React from 'react';

export const IconAddPhoto = (props: React.SVGProps<SVGSVGElement>) => (
	<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<path
			id="AddPhotoIconOriginal"
			fill="currentColor"
			overflow="visible"
			d="M20.074 10.017a3.559 3.559 0 0 0-3.552 3.553 3.559 3.559 0 0 0 3.552 3.552 3.559 3.559 0 0 0 3.553-3.552 3.559 3.559 0 0 0-3.553-3.553zm0 .873a2.673 2.673 0 0 1 2.68 2.68 2.673 2.673 0 0 1-2.68 2.679 2.673 2.673 0 0 1-2.679-2.68 2.673 2.673 0 0 1 2.68-2.679z"
		/>
		<path
			id="AddPhotoIconOriginal"
			fill="currentColor"
			overflow="visible"
			fillRule="evenodd"
			d="M6.199 3.572l-1.75 1.75h-3.14c-.168 0-.313.004-.476.064a.756.756 0 0 0-.401.381c-.133.323-.069.535-.069.874v11.778c0 .374-.067.59.077.92.072.166.256.32.418.373.162.053.302.055.468.055H19.32c.384 0 .736-.129.962-.38.226-.251.302-.575.302-.884v-1.076h-.873v1.076c0 .167-.04.257-.078.3-.04.044-.102.091-.313.091H1.326c-.058 0-.053-.002-.087-.005.008-.03-.003-.141-.003-.47V6.642c0-.302.008-.407.003-.442.03-.003.02-.005.07-.005h3.502l1.75-1.75h7.629l1.708 1.709h3.515c.147 0 .209.027.226.038.018.01.014.005.026.037.025.065.029.283.029.536v2.975h.872V6.764c0-.196.047-.502-.085-.848a.963.963 0 0 0-.391-.473c-.192-.116-.421-.163-.677-.163H16.26l-1.708-1.708H6.199z"
		/>
		<path
			id="AddPhotoIconOriginal"
			fill="currentColor"
			d="M19.692 11.75v3.583h.873v-3.582z"
			overflow="visible"
			fillRule="evenodd"
		/>
		<path
			id="AddPhotoIconOriginal"
			fill="currentColor"
			d="M18.326 13.117v.873h3.5v-.873z"
			overflow="visible"
			fillRule="evenodd"
		/>
		<path
			id="AddPhotoIconOriginal"
			fill="currentColor"
			overflow="visible"
			d="M10.32 8.05A4.425 4.425 0 0 0 5.9 12.466a4.425 4.425 0 0 0 4.419 4.419 4.425 4.425 0 0 0 4.418-4.419A4.425 4.425 0 0 0 10.32 8.05zm0 .872a3.539 3.539 0 0 1 3.545 3.545 3.539 3.539 0 0 1-3.545 3.546 3.54 3.54 0 0 1-3.546-3.546 3.539 3.539 0 0 1 3.546-3.545z"
		/>
		<path
			id="AddPhotoIconOriginal"
			fill="currentColor"
			overflow="visible"
			d="M10.306 10.047c-1.37 0-2.49 1.12-2.49 2.49 0 1.369 1.12 2.489 2.49 2.489s2.49-1.12 2.49-2.49-1.12-2.49-2.49-2.49zm0 .873a1.61 1.61 0 0 1 1.617 1.616 1.61 1.61 0 0 1-1.617 1.617 1.61 1.61 0 0 1-1.616-1.617 1.61 1.61 0 0 1 1.616-1.616zM17.636 7.126c-.777 0-1.415.639-1.415 1.415s.638 1.415 1.415 1.415c.776 0 1.414-.639 1.414-1.415s-.638-1.415-1.414-1.415zm0 .873c.304 0 .541.238.541.542a.535.535 0 0 1-.541.542.535.535 0 0 1-.542-.542c0-.304.237-.542.542-.542z"
		/>
	</svg>
);
